(() => {
  // Scope normalization to standalone wrappers, never the PDP's copied policy content.
  document.querySelectorAll('.sembonia-policy-page').forEach((page) => {
    const content = page.querySelector('.sembonia-policy-content');
    if (!content || page.dataset.policyReady) return;
    page.dataset.policyReady = 'true';
    content.querySelectorAll('.breadcrumbs-banner,.shopify-policy__title').forEach((el) => el.remove());
    // Remove editor-only blank spacing, not meaningful content or anchored links.
    content.querySelectorAll('p').forEach((p) => {
      if (!p.textContent.trim() && !p.querySelector('img,svg,iframe,a,video,input')) p.remove();
      while (p.lastChild && (p.lastChild.nodeName === 'BR' || (p.lastChild.nodeType === 3 && !p.lastChild.textContent.trim()))) p.lastChild.remove();
    });
    const headings = Array.from(content.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    headings.forEach((heading) => {
      const original = heading.textContent;
      if (original === original.toUpperCase()) {
        const formatted = original.toLowerCase().replace(/[a-z]/, (letter) => letter.toUpperCase())
          .replace(/\bi\b/g, 'I').replace(/\bsembonia\b/g, 'SEMBONIA').replace(/\bmalaysia\b/g, 'Malaysia')
          .replace(/\bp\.o\./g, 'P.O.').replace(/\b(myr|rm|fpx|sku|id|faq)\b/g, (word) => word.toUpperCase());
        const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        let offset = 0;
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const length = node.textContent.length;
          node.textContent = formatted.slice(offset, offset + length);
          offset += length;
        }
      }
      const previous = heading.previousElementSibling;
      if (previous && !/^H[1-6]$/.test(previous.tagName)) previous.classList.add('sembonia-policy-answer-end');
    });
    // Only remove initial spacing when the content actually starts with a heading.
    const first = headings[0];
    if (first) {
      const range = document.createRange();
      range.setStart(content, 0);
      range.setEndBefore(first);
      if (!range.toString().trim()) first.classList.add('sembonia-policy-first-heading');
    }
  });
})();
